import type { BaseStepType } from '@shared/patient-intake-status';

import type { StepConfigFor } from '../getStepConfig.types.ts';
import { MHRAccessStepConfig } from './MHRAccessStepConfig.tsx';
import { IdVerificationStepConfig } from './IdVerificationStepConfig.ts';
import { AccountVerificationStepConfig } from './AccountVerificationStepConfig.ts';
import { MedicareVerificationStepConfig } from './MedicareVerificationStepConfig.ts';
import { UploadHealthcareSummaryStepConfig } from './UploadHealthcareSummaryStepConfig.ts';
import { UploadReferralLetterOfSupportStepConfig } from './UploadReferralLetterOfSupportStepConfig.ts';
import { GenerateConsentToReleaseHealthSummaryStepConfig } from './GenerateConsentToReleaseHealthSummaryStepConfig.ts';

export const baseStepsConfig: {
  [K in BaseStepType]: StepConfigFor<K>;
} = {
  ID_VERIFICATION: IdVerificationStepConfig,
  MEDICARE_VERIFICATION: MedicareVerificationStepConfig,
  UPLOAD_HEALTHCARE_SUMMARY: UploadHealthcareSummaryStepConfig,
  UPLOAD_REFERRAL_LETTER_OF_SUPPORT: UploadReferralLetterOfSupportStepConfig,
  GENERATE_CONSENT_TO_RELEASE_HEALTH_SUMMARY: GenerateConsentToReleaseHealthSummaryStepConfig,
  MHR_ACCESS: MHRAccessStepConfig,
  ACCOUNT_VERIFICATION: AccountVerificationStepConfig,
};
